import LimitedCharacters from 'common/components/ui/LimitedCharacters';
import RoundNumber from 'common/components/ui/RoundNumber';
import React from 'react';
import { SDGTransformed } from 'sdgselection/types/SDG';
import '../styles/sdg-mini-item.css';

interface IProps {
  sdg: SDGTransformed;
  onSelect: (sdgId: number) => void;
  isSelected: boolean;
  index: number;
}

const SDGMiniItem: React.FC<IProps> = ({ sdg, onSelect, isSelected, index }) => {
  return (
    <div
      className={`sdg-mini-item ${isSelected ? 'sdg-mini-item--selected' : ''}`}
      onClick={() => onSelect(sdg.id)}
    >
      <div className="sdg-mini-item-icon">
        <RoundNumber text={`${index + 1}`} size={26} />
      </div>

      <div className="sdg-mini-item-content">
        <h6 className="sdg-mini-item-title">
          SDG {sdg.id} – {sdg.importance.title}
        </h6>
        <p className="sdg-mini-item-summary">
          <LimitedCharacters text={sdg.importance.summary} limit={40} />
        </p>
      </div>
    </div>
  );
};

export default SDGMiniItem;
